import { useState } from 'react';

import { Box, Button, TextField, Typography } from '@mui/material';

interface WizardCronStepProps {
  onNext: (schedule: string) => void;
  onSaveAndExit?: () => void;
  initialSchedule?: string;
}

export const WizardCronStep = ({ onNext, onSaveAndExit, initialSchedule }: WizardCronStepProps) => {
  const [cronExpression, setCronExpression] = useState(initialSchedule || '');

  const handleNext = () => {
    onNext(cronExpression);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Configure Schedule
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Set up a cron schedule for this integration
      </Typography>

      <TextField
        fullWidth
        label="Cron Expression"
        value={cronExpression}
        onChange={(e) => setCronExpression(e.target.value)}
        placeholder="0 0 * * *"
        helperText="Use standard cron format (minute hour day month weekday)"
        sx={{ mb: 3 }}
      />

      {/* TODO: Add CronBuilder component from existing implementation */}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Cron builder UI will be integrated here
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        {onSaveAndExit && (
          <Button variant="outlined" onClick={onSaveAndExit}>
            Save and Exit
          </Button>
        )}
        <Button variant="contained" onClick={handleNext} disabled={!cronExpression}>
          Next
        </Button>
      </Box>
    </Box>
  );
};
